export const normalizeEmploymentId = (value) =>
  value === null || value === undefined || value === ''
    ? null
    : String(value);
